import React from "react";
import "../../styles/ui.scss";

interface BCContactUsInfoProps {
  title: string;
  subtitle?: string;
  phone: string;
  email: string;
}

const BCContactUsInfo = ({ ...props }: BCContactUsInfoProps) => {
  return (
    <div className="contact-info-container">
      <div className="contact-info-header"><b>{props.title.toLocaleUpperCase()}</b>{props.subtitle && ` - ${props.subtitle}`}</div>
      <div className="contact-info-text">Phone: {props.phone}</div>
      <div className="contact-info-text">Email: {props.email}</div>
    </div>
  );
};

export default BCContactUsInfo;